
var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.dropdown = function () {
    return {
        open: false,
        container: {
            ['x-on:keydown.escape.stop']() {
                this.open = false;
            },
            ['x-on:click.away']() {
                this.open = false;
            },
        },
        trigger: {
            ['x-on:click']() {
                this.open = !this.open;
            },
            ['x-bind:aria-expanded']() {
                return this.open;
            }
        },
        dropdown: {
            ['x-show']() {
                return this.open;
            },

            ['x-transition:enter']: 'transition ease-out duration-200',
            ['x-transition:enter-start']: 'transform opacity-0 scale-95',
            ['x-transition:enter-end']: 'transform opacity-100 scale-100',
            ['x-transition:leave']: 'transition ease-in duration-75',
            ['x-transition:leave-start']: 'transform opacity-100 scale-100',
            ['x-transition:leave-end']: 'transform opacity-0 scale-95',
        }
    }
}